import React, { useEffect, useState } from 'react';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

import { AutoCompleteProps } from '../types';
import { KeyValue } from '../types';
import {
  InputWrapper,
  RenderOptionLi,
  SAutocomplete,
  SCheckbox,
  SRadio,
} from './select.style';
import { ErrorMessage, Label } from '../../Input/input/input.style';

const AutocompleteCreatable = ({
  name,
  value = [],
  options = [],
  placeholder = 'Search',
  handleChange,
  errorMessage = '',
  open,
  className,
  label,
  multiple = true,
  disabled,
  hideArrow = false,
  handleBlur,
  freeSolo = false,
  blurOnSelect = false,
  CustomPopper,
}: AutoCompleteProps) => {
  // todo: Refactor to manage local value by one state
  const [localValues, setLocalValues] = useState<any>([]);
  const [localObjValues, setLocalObjValues] = useState<any>([]);
  const [inputValue, setInputValue] = useState<string>('');
  let optionsLocal = [...options];

  if (multiple) {
    optionsLocal = [...[{ key: 'all', name: 'Select All' }], ...options];
  }

  const getRenderOptions = (
    props: any,
    option: { name: string; key: string },
    selected: boolean
  ) => {
    return (
      <RenderOptionLi checked={selected} {...props} key={option.key}>
        <span>{option.name}</span>
        {multiple ? (
          <SCheckbox
            color="primary"
            checked={localValues.includes(option.key)}
          />
        ) : (
          <SRadio color="primary" checked={localValues.includes(option.key)} />
        )}
      </RenderOptionLi>
    );
  };

  const handleSelectAllValues = (values: KeyValue[]) => {
    if (values.length === 1) {
      return optionsLocal.map((item: { key: string }) => item.key);
    }
    if (localValues.includes('all')) {
      return values
        .filter((item: { key: string }) => item.key !== 'all')
        .map((value: { key: string }) => value.key);
    } else {
      return optionsLocal.map((item) => item.key);
    }
  };

  const handleOptionValues = (values: KeyValue[]) => {
    if (values.length === options.length) {
      if (localValues.includes('all')) {
        return [];
      } else {
        return ['all', ...values.map((item: { key: string }) => item.key)];
      }
    } else {
      return [...values.map((item: { key: string }) => item.key)];
    }
  };

  const handleChangeValues = (_name: string, values: KeyValue | KeyValue[]) => {
    if (multiple && Array.isArray(values)) {
      let selectValues: string[] = [];
      let valuesExceptAll: string | string[] = [];
      let keyNameValues = [];
      if (values.find((i: { key: string }) => i.key === 'all')) {
        selectValues = handleSelectAllValues(values);
      } else {
        selectValues = handleOptionValues(values);
      }
      valuesExceptAll = selectValues.filter((i: string) => i !== 'all');
      keyNameValues = options.filter((i) => valuesExceptAll.includes(i.key));
      setLocalValues(selectValues);
      return handleChange(name, keyNameValues);
    } else {
      if (!Array.isArray(values)) {
        const { key } = values;
        setLocalValues([key]);
        handleChange(name, [values]);
      }
    }
  };

  useEffect(() => {
    if (typeof value === 'string') return;

    if (value?.length === options.length) {
      setLocalValues(['all', ...value.map((item) => item.key)]);
      setLocalObjValues([{ key: 'all', name: 'Select All' }, ...value]);
    } else {
      setLocalValues(value.map((item) => item.key));
      setLocalObjValues([...value]);
    }
  }, [value?.length]);

  return (
    <InputWrapper className={className}>
      {label && (
        <Label component="legend" disabled={disabled}>
          {label}
        </Label>
      )}
      <SAutocomplete
        open={open}
        value={
          // freeSolo ? localObjValues : null is necessary to hide selected value in solo select
          typeof value === 'string' ? value : freeSolo ? localObjValues : null
        }
        disableClearable
        freeSolo={freeSolo}
        blurOnSelect={blurOnSelect}
        onChange={(_event: any, values: any) => {
          if (
            localValues.includes('all') &&
            values.length === 1 &&
            values[0].key === 'all'
          ) {
            return handleChangeValues(name, []);
          } else {
            return handleChangeValues(name, values);
          }
        }}
        renderTags={() => null}
        options={optionsLocal}
        onClose={handleBlur}
        popupIcon={!hideArrow && <ArrowDropDownIcon />}
        isOptionEqualToValue={(option: any, value: any) =>
          option.key === (typeof value === 'string' ? value : value.key)
        }
        //In mui Documentation cant't find option type that is why give any
        getOptionLabel={(option: any) => {
          if (typeof option === 'string') {
            return options.find((item) => item.key === value)?.name || '';
          }
          if (!Array.isArray(option)) {
            return option.name;
          }
          return option[0] ? option[0].name : '';
        }}
        inputValue={multiple ? inputValue : undefined}
        onInputChange={
          multiple
            ? (event, value, reason) => {
                if (event && event.type === 'blur') {
                  setInputValue('');
                } else if (reason !== 'reset') {
                  setInputValue(value);
                }
              }
            : undefined
        }
        disabled={disabled}
        multiple={multiple}
        PopperComponent={CustomPopper}
        disableCloseOnSelect={multiple}
        //In mui Documentation cant't find option type that is why give any
        //In mui Documentation cant't find props type that is why give any
        renderOption={(
          props: any,
          option: any,
          { selected }: { selected: boolean }
        ) => getRenderOptions(props, option, selected)}
        renderInput={(params: JSX.IntrinsicAttributes & TextFieldProps) => (
          <TextField
            {...params}
            name={name}
            id="standard-search"
            placeholder={placeholder}
            type="search"
            variant="outlined"
          />
        )}
      />
      {errorMessage && (
        <ErrorMessage
          className="error-autoComplete"
          component="p"
          variant="body1"
        >
          {errorMessage}
        </ErrorMessage>
      )}
    </InputWrapper>
  );
};

export { AutocompleteCreatable as AutoComplete };
